import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=547a5cbc&scoped=true&"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPassword.vue?vue&type=style&index=0&id=547a5cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a5cbc",
  null
  
)

export default component.exports